import { render } from "./AvaliacaoLista.vue?vue&type=template&id=1a36d5f8"
import script from "./AvaliacaoLista.vue?vue&type=script&lang=js"
export * from "./AvaliacaoLista.vue?vue&type=script&lang=js"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__